<template>
	<div>
		<div class="title-container">
			<div class="title">
				Modules
				<div class="subtitle"><span class="fa fa-globe"></span> {{ account.name }}</div>
			</div>
			<div class="buttons">
				<router-link :to="{ name: 'super-account-extensions-page', params: $route.params }" class="button"><div class="hover-title">Redactor Extras</div><span class="fa fa-th-large"></span></router-link>
				<router-link :to="{ name: 'super-account-webhooks-page', params: $route.params }" class="button"><div class="hover-title">Webhooks</div><span class="fa fa-candy-cane"></span></router-link>
				<router-link :to="{ name: 'super-account-triggers-page', params: $route.params }" class="button"><div class="hover-title">Triggers</div><span class="fa fa-raygun"></span></router-link>
				<router-link :to="{ name: 'super-account-flags-page', params: $route.params }" class="button"><div class="hover-title">Flags</div><span class="fa fa-flag"></span></router-link>
				<router-link :to="{ name: 'super-account-modules-create-page', params: $route.params }" class="button"><div class="hover-title">Add Module</div><span class="fa fa-plus"></span></router-link>
			</div>
		</div>
		<nothing-here v-if="modules.length === 0"></nothing-here>
		<div v-else class="table-scroll-wrapper">
			<div class="table list">
				<div v-if="modules.length > 0" class="row sortable">
					<div class="cell buttons">
						<a v-if="!isOrdering" href @click.prevent="enableDragging" class="button" data-ytta-id="-"><div class="hover-title">Custom Sort</div><span class="fa fa-sort" aria-hidden="true"></span></a>
						<a v-else href @click.prevent="isOrdering = false" class="button" data-ytta-id="-"><div class="hover-title">Stop Sorting</div><span class="fa fa-save" aria-hidden="true"></span></a>
					</div>
					<div class="cell">Name</div>
					<div class="cell">Assoc. Modules</div>
					<div class="cell">Photo Gallery</div>
					<div class="cell">File Gallery</div>
				</div>
				<tbody v-sortable="{ onUpdate: reorderRows, handle: '.row', disabled: !isOrdering, scroll: true }">
					<div v-for="module in modules" :key="`account-${ account.id }-module-${ module.id }`" class="row" :class="{ 'crud-item': isOrdering }">
						<div class="cell buttons">
							<delete-button @deleted="(done) => deleteRow(module, done)" :can-delete="!module.is_curated_module">
								<router-link :to="`/admin/accounts/${ account.id }/modules/${ module.id }/edit`" class="button"><div class="hover-title">Update</div><span class="fa fa-pencil"></span></router-link>
							</delete-button>
						</div>
						<div class="cell"><span v-if="module.is_nav_heading === 1" style="font-weight:900;">Nav Title<span class="fa fa-arrow-right" style="padding:0px 7.5px;"></span></span><a href @click.prevent="viewModule(module)" class="link">{{ module.name }}</a></div>
						<div class="cell">{{ (module.counts.associated_module || []).length > 0 ? 'Yes' : 'No' }}</div>
						<div class="cell">{{ (module.counts.photo_gallery || []).length > 0 ? 'Yes' : 'No' }}</div>
						<div class="cell">{{ (module.counts.file_gallery || []).length > 0 ? 'Yes' : 'No' }}</div>
					</div>
				</tbody>
			</div>
		</div>
	</div>
</template>

<script>

import DeleteButton from '@/views/components/DeleteButton';

export default {

	async asyncData({ app, route, store }) {
		const { data } = await app.$api.get(`/super/accounts/${ route.params.accountId }/modules`);

		return {
			modules: data.data,
			account: store.state.auth.accountsById[ route.params.accountId ],
		};
	},

	data() {
		return {
			// Whether or not they are actively drag & drop sorting
			isOrdering: false,
		};
	},

	methods: {

		saveSort() {
			const rows = this.modules.map((row, index) => {
				return { id: row.id, order: index };
			});

			this.$api.post(`/super/accounts/${this.account.id}/module/order`, { rows }).then(() => {
				this.$store.dispatch('addToast', 'Sort Position Saved');
			});
		},

		enableDragging() {
			this.isOrdering = true;
		},

		reorderRows(event) {
			this.modules.splice(event.newIndex, 0, this.modules.splice(event.oldIndex, 1)[ 0 ]);
			this.saveSort();
		},

		async viewModule(module) {
			await this.$store.dispatch('switchAccount', this.account.id);
			this.$router.push(`/module/${ module.slug }`);
		},

		async deleteRow(module, done) {
			await this.$api.post(`/super/accounts/${this.account.id}/modules/${ module.id }/delete`).then(() => {
				this.$store.dispatch('addToast', module.name + ' Deleted');
				this.modules = this.modules.filter(m => m.id !== module.id);
				done();
			});
		}

	},

	components: {
		DeleteButton,
	},

};

</script>
